var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductDetails',{attrs:{"product":_vm.product,"is-fetching":_vm.isFetching},scopedSlots:_vm._u([{key:"options",fn:function(ref){
var productPrice = ref.productPrice;
return [(_vm.product.options && _vm.product.options.length)?_c('ProductOptions',{attrs:{"options":_vm.product.options,"product-price":productPrice}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }